import React, {Component} from 'react';
import {connect} from "react-redux";
import {Button, Form, FormControl} from "react-bootstrap";
import md5 from 'md5';
import {Carousel} from 'react-bootstrap';
// import IMask from "imask";

import {parseQuery} from "../../lib";

import Aside from "../../components/Aside/Aside";
import config from "../../config";
import Preloader from "../../components/UI/Preloader/Preloader";
import MessageModal from "../../components/UI/Modals/MessageModal";
import LoginModal from "../../components/UI/Modals/LoginModal";
import PictureViewer from "../../components/UI/PictureViewer/PictureViewer";
import {fetchAdvertising, fetchAnnouncement} from "../../store/actions/main";
import {createForum} from "../../store/actions/forums";
import {fetchCategories} from "../../store/actions/filters";
import {addVote, checkVoted, fetchPracticeVotes} from "../../store/actions/vote";
import {fetchCurrentUser} from "../../store/actions/users";
import {login} from "../../store/actions/auth";
import {fetchBestPractices} from "../../store/actions/bestPractices";

class AsideMain extends Component {
  state = {
    forumQuestion: '',
    thematicId: '',
    category: '',
    messageModal: false,
    check: '',
    loginModal: false,
    email: '',
    password: '',
    loginModalMessage: '',
    bestPractices: [],
    practiceString: '',
    currentUser: {},
    picViewer: false,
    carouselItem: '',
    loginErrorMessage: ''
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    let practiceString;
    const state = {};
    if (nextProps.bestPractices !== prevState.bestPractices) {
      state.bestPractices = nextProps.bestPractices;
      practiceString = nextProps.bestPractices.map(el => el.id);
      if (practiceString.length) {
        practiceString = md5(practiceString.sort((a, b) => a - b).join(','));
        if (practiceString !== prevState.practiceString) {

          nextProps.onCheckVoted({vote_key: practiceString});
          nextProps.bestPractices.forEach(el => {
            nextProps.onFetchPracticeVotes(parseQuery({vote_key: practiceString, practice_id: el.id}));
          });
          return {...state, practiceString}
        }
      }
      return {...state};
    }

    if (nextProps.language !== prevState.language) {
      nextProps.onFetchAnnouncement(parseQuery({lang: nextProps.language}));
      nextProps.onFetchBestPractices(parseQuery({lang: nextProps.language, practice_vote: 1, status: 1}));
      return {language: nextProps.language}
    }

    return null;
  }

  componentDidMount() {
    this.props.onFetchAdvertising(parseQuery({lang: this.props.language, status: 1}));
    this.props.onFetchAnnouncement(parseQuery({lang: this.props.language}));
    this.props.onFetchBestPractices(parseQuery({lang: this.props.language, practice_vote: 1, status: 1}));
  }

  toggleMessageModal = () => {
    this.setState(prevProps => {
      return {messageModal: !prevProps.messageModal};
    })
  };

  handleCloseModal = data => {
    if (data.close) this.setState({messageModal: false})
  };

  toggleLoginModal = () => {
    this.setState(prevProps => {
      return {loginModal: !prevProps.loginModal}
    });
  };

  onCloseLoginModal = () => {
    this.setState({loginModal: false, email: '', password: '', loginModalMessage: ''})
  };

  onChangeHandler = event => {
    // if (event.target.value.match(/\d+/g) !== null && event.target.name === 'email') {
    //   let element = document.getElementById('emailaside');
    //   let maskOptions = {
    //     mask: '+{996}(000)00-00-00'
    //   }
    //   let mask = IMask(element, maskOptions);
    //   this.setState({[event.target.name]: mask._value});
    //   mask.destroy();
    // } else
      this.setState({[event.target.name]: event.target.value});
  };

  onSubmitHandler = async event => {
    const {t} = this.props;
    event.preventDefault();
    let email;

    if (this.state.email.includes('+996(')) {
      email = this.state.email
        .replace('(', '')
        .replace(')', '')
        .replace('-', '')
        .replace('-', '');
    } else email = this.state.email
    let data = {
      email: email,
      password: this.state.password
    };

    await this.props.onLogin(data);

    if (this.props.loginError !== null) {
      this.setState({loginErrorMessage: t("header.loginError")})
    } else {
      this.props.onFetchCurrentUser();
      this.setState({loginErrorMessage: ''})
      this.onCloseLoginModal();
      this.props.redirectOn('Main', parseQuery({lang: this.props.language}));
    }
  };

  handleRedirectToPublishPractice = () => {
    const {t} = this.props;
    if (!!Object.keys(this.props.currentUser).length) this.props.redirectOn('Fill best practice', parseQuery({lang: this.props.language}));

    if (!Object.keys(this.props.currentUser).length) {
      this.setState({loginModalMessage: t("loginModal.publishAPractice")});
      this.toggleLoginModal();
    }
  };

  handleSelect = event => {
    if (event.target.value !== '0') this.setState({[event.target.name]: event.target.value});

    if (event.target.name === 'thematicId') {
      this.props.onFetchCategories(parseQuery({lang: this.props.language, thematics_id: event.target.value}));
    }
  };

  handleChange = event => {
    this.setState({[event.target.name]: event.target.value});
  };

  handleQuestionCreate = async event => {
    const {t} = this.props;
    event.preventDefault();
    let data = {
      question: this.state.forumQuestion,
      thematic_id: parseInt(this.state.thematicId, 10),
      category_id: parseInt(this.state.category, 10)
    };
    if (this.state.thematicId && this.state.category && this.state.forumQuestion && !!Object.keys(this.props.currentUser).length) {
      await this.props.onCreateForum(data);
    }

    if (this.props.status === 200) {
      this.toggleMessageModal();
      this.setState({forumQuestion: '', thematicId: '', category: ''})
    }

    if (!Object.keys(this.props.currentUser).length) {
      this.setState({loginModalMessage: t("loginModal.askAQuestion")});
      this.toggleLoginModal();
    }
  };

  handleCheck = (event, id) => {
    this.setState({check: id})
  };

  handleAddVote = async () => {
	//var str = JSON.stringify(this.props.currentUser.email_verified_at);
	if(this.props.currentUser.id == null){
		window.alert('Внимание! Для того, чтобы принять участие в голосование, Вам необходимо зайти на портал используя ваши Логин и Пароль. Для этого в верхней части портала нажмите Вход.');
	}
	else if(this.props.currentUser.email_verified_at == null){
		window.alert('Внимание! Для того, чтобы принять участие в голосование, Вам необходимо подтветдить ваш номер телефона, указанный при регистрации. Для этого отправьте с вашего WhatsApp сообщение администратору Портала. Для этого нажмите кнопку OK');
		window.open(
		  'https://wa.me/996777217075/?text=Пожалуйста%20активируйте%20мой%20аккаунт! http%3A%2F%2Fadmin.ma.dcasa.kg%2Fadmin%2Fverifyphone%2F' + this.props.currentUser.id,
		  '_blank' // <- This is what makes it open in a new window.
		);
	}
	else {
		//window.alert('Все нормально ваш номер активирован! Вы можете голосовать!');
    const {t} = this.props;
    let practiceString;

    if (this.props.bestPractices && this.props.bestPractices.length) {
      practiceString = this.props.bestPractices.map(el => el.id);
    }

    practiceString = md5(practiceString.sort((a, b) => a - b).join(','));

    await this.props.onAddVote({practice_id: this.state.check, vote_key: practiceString});


    this.props.onCheckVoted({vote_key: practiceString});

    if (!Object.keys(this.props.currentUser).length) {
      this.setState({loginModalMessage: t("loginModal.vote")});
      this.toggleLoginModal();
    }
	}
  };

  handleRedirectToPractice = (event, item) => {
    this.props.redirectOn('Best practice example', parseQuery({lang: this.props.language, id: item.id}))
  };

  handleOpenViewer = item => {
    this.setState(prevProps => {
      return {picViewer: !prevProps.picViewer, carouselItem: item.image}
    })
  };

  handleCloseViewer = () => {
    this.setState({picViewer: false});
  };

  render() {
    const {t} = this.props;
    let advertisingImage, advertisingDescription, thematics, categories, bestPractices, advertisingArray,
      advertisingSlide, slideItem, announcement;

    if (this.props.advertising && this.props.advertising.length) {
      advertisingArray = this.props.advertising.map(el => {
        return el;
      });

      advertisingSlide = advertisingArray.map((el, idx) => {
        const imageUrl = config.apiUrl + '/storage/' + el.image.replace('"', '');
        return (
          el.image ?
            <Carousel.Item key={idx}>
              {imageUrl ?
                el.link ?
                  <a href={el.link} target="_blank" rel="noopener noreferrer">
                    <img
                      className="d-block w-100"
                      src={config.apiUrl + '/storage/' + el.image.replace('"', '')}
                      alt=""
                      onClick={() => this.handleOpenViewer(el)}
                    />
                  </a> :
                  <img
                    className="d-block w-100"
                    src={config.apiUrl + '/storage/' + el.image.replace('"', '')}
                    alt=""
                    onClick={() => this.handleOpenViewer(el)}
                  />
                : <Preloader/>}
            </Carousel.Item> : []
        )
      });

      slideItem = advertisingSlide && advertisingSlide.length ?
        <Carousel nextIcon={false}
                  prevIcon={false}
                  indicators={false}
                  interval={3000}
                  controls={false}
                  style={{cursor: 'pointer'}}
        >{advertisingSlide}</Carousel> : null;
    }

    try {
      advertisingImage = this.props.advertising[0].image
    } catch (e) {
      advertisingImage = null;
    }

    try {
      advertisingDescription = this.props.advertising[0].description
    } catch (e) {

    }

    if (this.props.thematicList && this.props.thematicList.length) {
      thematics = this.props.thematicList.map(el => {
        return (
          <option key={el.id} value={el.id} id={el.id}>{el.title}</option>
        )
      })
    }

    if (this.props.categories && this.props.categories.length) {
      categories = this.props.categories.map(el => {
        return (
          <option key={el.id} value={el.id} id={el.id}>{el.title}</option>
        )
      })
    }

    if (this.props.bestPractices && this.props.bestPractices.length) {
      const valuesSum = Object.keys(this.props.practiceVotes).length ?
        Object.values(this.props.practiceVotes).reduce((acc, e) => acc + e) : 1;
      bestPractices = this.props.bestPractices.map((el) => {
        const voteLength = this.props.practiceVotes[el.id] ? Math.round(this.props.practiceVotes[el.id] / valuesSum * 100) : 0;
        return (
          <div className="vote-wrapper__block" key={el.id}>
            <p onClick={e => this.handleRedirectToPractice(e, el)}>{el.title}</p>
            <div className="progress-block" onClick={e => this.handleCheck(e, el.id)}>
              <label className="progress-block__radio">
                <input name="radio"
                       type="radio"
                       id={el.id}
                       checked={this.state.check === el.id}
                       onChange={e => this.handleCheck(e, el.id)}
                  // className="progress-block__input"
                />
                <span className="progress-block__input">
                </span>
              </label>
              <div className="progress-block__progressbar">
                <div style={{flex: `${voteLength}`}}>
                </div>
                <div style={{flex: `calc(100 - ${voteLength})`}}>
                </div>
              </div>
              <div className="progress-block__percent">{this.props.practiceVotes[el.id]}</div>
            </div>
          </div>
        )
      })
    }

    if (this.props.announcements && this.props.announcements.length) {
      announcement = this.props.announcements[0].description;
    }

    return (
      <Aside.Wrapper>
        <Aside.Item
          className={`aside__ad-block ${this.props.advertising.length && advertisingImage ? 'aside__ad-block--advertising' : 'aside__ad-block--default'}`}>
          {this.props.advertisingLoading ? <Preloader/> : <div>
            {/*здесь одна картинка, на всякий случай не убираю*/}
            {/*<img src={this.props.advertising.length && advertisingImage ? config.apiUrl + '/storage/' + advertisingImage : null}*/}
            {/*     alt=""*/}
            {/*     width={this.props.advertising.length && advertisingImage ? "100%" : ''}*/}
            {/*     height={this.props.advertising.length && advertisingImage ? "auto" : ''}*/}
            {/*/>*/}
            {slideItem}
            {this.props.advertising.length && advertisingImage ?
              null :
              <div className="aside__ad-block--description" dangerouslySetInnerHTML={{__html: advertisingDescription}}/>
            }
          </div>}
        </Aside.Item>

        <Aside.Item className="light-bg aside__feedback">
          <h3 className="aside-title">
            {t('aside.feedback.title')}
          </h3>
          <p className="aside-text">
            {t('aside.feedback.description')}
          </p>
          <Button variant="success" onClick={e => this.handleRedirectToPublishPractice(e)}>
            {t('aside.feedback.button')}
          </Button>
        </Aside.Item>

        {this.props.announcements && this.props.announcements.length ?
          this.props.loadingAnnouncement ? <Preloader/> :
          <Aside.Item className="light-bg aside__feedback">
          <div dangerouslySetInnerHTML={{__html: announcement}}/>
        </Aside.Item> : null}

        <Aside.Item className="light-bg aside__vote">
          <h3 className="aside-title">
            {t('aside.vote.title')}
          </h3>
          <div className="vote-wrapper">
            {this.props.practiceVotesLoading ? <Preloader/> : bestPractices}
          </div>
          {!this.props.voted.voted ?
            Object.keys(this.props.voted).length && Object.keys(this.props.currentUser).length && this.state.check !== '' ?
              <Button variant="success"
                      onClick={this.handleAddVote}
              >
                {t('aside.vote.button')}
              </Button> :
              <Button variant="success"
                      onClick={this.handleAddVote}
                      //disabled
              >
                {t('aside.vote.button')}
              </Button> :
            <Button variant="secondary" disabled>
              {t('aside.vote.button secondary')}
            </Button>}
        </Aside.Item>

        <Aside.Item className="light-bg aside__question-form">
          <h3 className="aside-title">
            {t('aside.question form.title')}
          </h3>
          <Form>
            <FormControl as="select"
                         className="aside__select"
                         name="thematicId"
                         onClick={this.handleSelect}
            >
              <option value='0' id='0'>{t("aside.question form.thematicSection")}</option>
              {thematics}
            </FormControl>

            <FormControl as="select"
                         className="aside__select"
                         name="category"
                         onClick={this.handleSelect}
            >
              <option value='0' id='0'>{t("aside.question form.category")}</option>
              {categories}
            </FormControl>

            <Form.Group controlId="question">
              <Form.Control as="textarea"
                            rows="7"
                            placeholder={t('aside.question form.description')}
                            name="forumQuestion"
                            value={this.state.forumQuestion}
                            onChange={this.handleChange}
              />
            </Form.Group>
            {this.state.thematicId && this.state.category && this.state.forumQuestion ?
              <Button variant="success" type="submit" onClick={this.handleQuestionCreate}>
                {t('aside.question form.button')}
              </Button> :
              <Button variant="success" type="submit" disabled onClick={this.handleQuestionCreate}>
                {t('aside.question form.button')}
              </Button>}
          </Form>
        </Aside.Item>

        {/*<Aside.Item className="medium-bg aside__donate">
          <h3 className="aside-title">
            {t('aside.donate.title')}
          </h3>
          <p className="aside-text">
            {t('aside.donate.description')}
          </p>
          <h5 className="aside-subtitle">
            {t('aside.donate.subtitle')}
          </h5>
          <p className="aside-text">
            {t('aside.donate.contacts')}
          </p>
        </Aside.Item>*/}
        <MessageModal {...this.props}
                      messageModal={this.state.messageModal}
                      onOk={(data) => this.handleCloseModal(data)}
                      message={t("messageModal.message")}
        />
        {this.state.loginModal ?
          <LoginModal {...this.props}
                      asideCheck
                      loginModal={this.state.loginModal}
                      onClose={this.onCloseLoginModal}
                      onChange={e => this.onChangeHandler(e)}
                      onSubmit={e => this.onSubmitHandler(e)}
                      message={this.state.loginModalMessage}
                      error={this.state.loginErrorMessage}
                      id={'aside'}
          /> : null}
        {this.state.picViewer ?
          this.props.pageWidth >= 830 ?
            <PictureViewer {...this.props}
                           array={this.props.advertising}
                           picViewer={this.state.picViewer}
                           onClose={this.handleCloseViewer}
                           item={this.state.carouselItem}
            /> :
            null : null}
      </Aside.Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  advertising: state.main.advertising,
  advertisingLoading: state.main.advertisingLoading,
  categories: state.filters.categories,
  status: state.forums.status,
  voted: state.vote.voted,
  practiceVotes: state.vote.practiceVotes,
  practiceVotesLoading: state.vote.practiceVotesLoading,
  loginError: state.auth.loginError,
  announcements: state.main.announcements,
  loadingAnnouncement: state.main.loadingAnnouncement,
  currentUser: state.users.currentUser
});

const mapDispatchToProps = dispatch => ({
  onFetchAdvertising: query => dispatch(fetchAdvertising(query)),
  onCreateForum: data => dispatch(createForum(data)),
  onFetchCategories: query => dispatch(fetchCategories(query)),
  onAddVote: data => dispatch(addVote(data)),
  onFetchCurrentUser: () => dispatch(fetchCurrentUser()),
  onLogin: data => dispatch(login(data)),
  onCheckVoted: data => dispatch(checkVoted(data)),
  onFetchPracticeVotes: query => dispatch(fetchPracticeVotes(query)),
  onFetchAnnouncement: query => dispatch(fetchAnnouncement(query)),
  onFetchBestPractices: query => dispatch(fetchBestPractices(query)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AsideMain);
